var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSidebarMaster(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun-web-page-640190",
    transform: "translate(-78.75 -8.75)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37619",
    "data-name": "Path 37619",
    d: "M96.034,8.75H80.466a1.71,1.71,0,0,0-1.716,1.626V14.5h19V10.376A1.71,1.71,0,0,0,96.034,8.75ZM83.163,12.06H81.569a.465.465,0,1,1,0-.929H83.1a.472.472,0,0,1,.49.465A.458.458,0,0,1,83.163,12.06Zm3.187,0H84.818a.465.465,0,1,1,0-.929H86.35a.472.472,0,0,1,.49.465A.514.514,0,0,1,86.35,12.06Z",
    fill: "#61277f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37620",
    "data-name": "Path 37620",
    d: "M78.75,208.25V218a1.71,1.71,0,0,0,1.716,1.626H96.034A1.71,1.71,0,0,0,97.75,218V208.25Zm3.126,2.381a.471.471,0,0,1,.49-.465h3.187a.472.472,0,0,1,.49.465v2.961a.471.471,0,0,1-.49.465H82.366a.472.472,0,0,1-.49-.465ZM94.2,217.018H82.3a.465.465,0,1,1,0-.929H94.134a.472.472,0,0,1,.49.465A.423.423,0,0,1,94.2,217.018Zm0-2.961H88.556a.465.465,0,1,1,0-.929H94.2a.472.472,0,0,1,.49.465A.57.57,0,0,1,94.2,214.056Zm0-2.961H88.556a.465.465,0,1,1,0-.929H94.2a.472.472,0,0,1,.49.465A.57.57,0,0,1,94.2,211.1Z",
    transform: "translate(0 -191.881)",
    fill: "#61277f"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarMaster);
export default __webpack_public_path__ + "static/media/sidebar-master.20b608d8b5bf1f163fa576d39dc9c255.svg";
export { ForwardRef as ReactComponent };